import React from "react";
import { useFormik } from "formik";

const validate = (values) => {
  const errors = {};

  if (!values.firstName) {
    errors.firstName = "First name is required";
  }

  if (!values.lastName) {
    errors.lastName = "Last name is required";
  }

  if (!values.email) {
    errors.email = "Email address is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  if (!values.phone) {
    errors.phone = "Phone is required";
  } else if (!/^[\d+\-\s()]{6,}$/.test(values.phone)) {
    errors.phone = "Invalid phone number";
  }

  // Message is optional, so no validation

  return errors;
};

const ContactPageForm = () => {
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      message: "",
    },
    validate,
    onSubmit: (values) => {
      // Construct mailto string
      const mailto = `mailto:info@videovision.io?subject=Contact%20Form%20Submission%20from%20${encodeURIComponent(
        values.firstName + " " + values.lastName
      )}&body=${encodeURIComponent(
        `First Name: ${values.firstName}
Last Name: ${values.lastName}
Email: ${values.email}
Phone: ${values.phone}
Message: ${values.message || "(No message)"}`
      )}`;
      window.location.href = mailto;
    },
  });

  return (
    <div className="contact-page-form">
      <h3>Personal information </h3>
      <form onSubmit={formik.handleSubmit} autoComplete="off">
        <div className="row">
          <div className="col-lg-6 col-12">
            <div className="form-group style-2">
              <label htmlFor="firstName">First name *</label>
              <div className="inp-grp">
                <input
                  id="firstName"
                  name="firstName"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.firstName}
                  className={
                    formik.touched.firstName && formik.errors.firstName
                      ? "error"
                      : ""
                  }
                />
              </div>
              {formik.touched.firstName && formik.errors.firstName ? (
                <div className="form-error">{formik.errors.firstName}</div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="form-group style-2">
              <label htmlFor="lastName">Last name *</label>
              <div className="inp-grp">
                <input
                  id="lastName"
                  name="lastName"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.lastName}
                  className={
                    formik.touched.lastName && formik.errors.lastName
                      ? "error"
                      : ""
                  }
                />
              </div>
              {formik.touched.lastName && formik.errors.lastName ? (
                <div className="form-error">{formik.errors.lastName}</div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="form-group style-2">
              <label htmlFor="email">Email address *</label>
              <div className="inp-grp">
                <input
                  id="email"
                  name="email"
                  type="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  className={
                    formik.touched.email && formik.errors.email ? "error" : ""
                  }
                />
              </div>
              {formik.touched.email && formik.errors.email ? (
                <div className="form-error">{formik.errors.email}</div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="form-group style-2">
              <label htmlFor="phone">Phone *</label>
              <div className="inp-grp">
                <input
                  id="phone"
                  name="phone"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phone}
                  className={
                    formik.touched.phone && formik.errors.phone ? "error" : ""
                  }
                />
              </div>
              {formik.touched.phone && formik.errors.phone ? (
                <div className="form-error">{formik.errors.phone}</div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-12 col-12">
            <div className="form-group style-2">
              <label htmlFor="message">Your Message (optional)</label>
              <div className="inp-grp">
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.message}
                />
              </div>
            </div>
          </div>
          <div className="col-12">
            <button
              className="main-btn gray-btn wide"
              type="submit"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? (
                <span>Submitting...</span>
              ) : (
                <span>Submit</span>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ContactPageForm;
